import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { updateEvent as updateEventApi } from "../api/event.api";
import type { EventItemResponse, UpdateEventForAdminRequest } from "../types/event.types";

interface UseUpdateEventReturn {
  updateEvent: (id: string, request: UpdateEventForAdminRequest) => Promise<EventItemResponse>;
  loading: boolean;
  error: string | null;
}

export const useUpdateEvent = (): UseUpdateEventReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateEvent = useCallback(
    async (id: string, request: UpdateEventForAdminRequest): Promise<EventItemResponse> => {
      try {
        setLoading(true);
        setError(null);
        return await updateEventApi(id, request);
      } catch (updateError: unknown) {
        setError(getApiErrorMessage(updateError, "Failed to update event"));
        throw updateError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { updateEvent, loading, error };
};
